'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.349 3.948a6.187 6.187 0 0 1-1.49-1.133 4.103 4.103 0 0 1-.448-.539c.722.364 1.481.646 2.265.843.354.088.715.144 1.08.167.382.023.766-.008 1.14-.091a3.773 3.773 0 0 0 2.006-1.245c.352-.386.733-.745 1.14-1.072.217-.194.467-.348.737-.456.245-.136.508-.237.782-.297a3.597 3.597 0 0 1 1.574-.068c.444.078.872.227 1.269.441a5.115 5.115 0 0 1 1.474 1.2c.152.18.29.37.411.57 0 0-.222-.13-.609-.326a7.513 7.513 0 0 0-1.603-.61 3.35 3.35 0 0 0-2.105.108 3.008 3.008 0 0 0-.965.593c-.282.168-.662.675-.965.98a4.643 4.643 0 0 1-2.95 1.536 3.968 3.968 0 0 1-1.52-.123 4.847 4.847 0 0 1-1.223-.478Zm13.374.432v-.259l1.51 18.945c.035.812-.405.934-.935.934H.775A.775.775 0 0 1 0 23.225v-7.664a.772.772 0 0 1 .33-.582l.15-.08 3.236-1.739a.315.315 0 0 1 .464.278v1.309a.244.244 0 0 0 .36.215l3.357-1.802a.315.315 0 0 1 .464.278v1.31a.244.244 0 0 0 .36.214l3.356-1.802a.315.315 0 0 1 .464.278v1.309a.244.244 0 0 0 .36.215l3.357-1.802a.315.315 0 0 1 .464.278v1.359a.244.244 0 0 0 .334.227l.77-.303a.619.619 0 0 0 .39-.524l.847-10.008a.772.772 0 0 1 .726-.577l.02-.002h1.181l.02.002a.77.77 0 0 1 .708.72c.001.016.005.032.005.048ZM5.663 21.804V20.03h-4.18v1.773h4.18Zm5.512 0V20.03h-4.18v1.773h4.18Zm5.511 0V20.03h-4.18v1.773h4.18Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var Industry = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Industry = Industry;